import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import { useUncategorizedCategory } from "@hooks/useUncategorizedCategory";
import { AuditLogActor } from "../AuditLogActor";

interface Props {
    log: AuditLog;
}

export const TransactionLogCreatedContent: React.FC<Props> = ({ log }) => {
    const { enabled: isGlFirst } = useIsGlFirst();
    const uncategorized = useUncategorizedCategory();
    const authorComponent = (
        <AuditLogActor
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            log={log}
        />
    );

    // GL-first workspaces hide category, so describe the creation by the
    // account the transaction landed in instead of its category.
    if (isGlFirst) {
        const accountLabel =
            log.diff.find((d) => d.field === "accountId")?.after?.valueLabel ??
            "";
        return (
            <>
                <strong>{authorComponent}</strong> created the transaction in{" "}
                <strong>{accountLabel}</strong> account.
            </>
        );
    }

    const categoryAfter = log.diff.find((d) => d.field === "categoryId")?.after;
    const newCategoryLabel = categoryAfter?.valueLabel ?? "";
    const isUncategorized =
        newCategoryLabel === "Uncategorized" ||
        (uncategorized !== undefined &&
            categoryAfter?.value === uncategorized.id);

    if (isUncategorized || !newCategoryLabel) {
        return (
            <>
                <strong>{authorComponent}</strong> created the transaction.
            </>
        );
    }

    return (
        <>
            <strong>{authorComponent}</strong> created the transaction with{" "}
            <strong>{newCategoryLabel}</strong> category.
        </>
    );
};
